<template>
  <div class="salesExportExcel">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="changeOrder">
      <div slot="toolbar" style="margin-bottom: 10px">
        <el-button v-loading="exportLoading" type="primary" @click="exportExcel">导出</el-button>
        <el-button v-loading="exportLoading" type="primary" @click="exportSalesChangeOrderQuality">质量部待办导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="变更编号">
            <el-input v-model.trim="filter.salesChangeOrderNO" style="width: 150px" clearable/>
          </vm-search>
          <vm-search label="创建人">
            <el-input v-model.trim="filter.creator" style="width: 150px" clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.orderNoStr" style="width: 150px" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" style="width: 150px" clearable/>
          </vm-search>
          <vm-search label="申请人类型">
            <el-select v-model="filter.departmentName" filterable clearable>
              <el-option
                  v-for="item in departmentList"
                  :key="item.departmentID"
                  :label="item.departmentName"
                  :value="item.departmentName"
                  @click.native="selectDepartment(item)"/>
            </el-select>
          </vm-search>
          <vm-search label="到达日期">
            <div class="block">
              <el-date-picker
                  v-model="filter.arriveTimeBegin"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 165px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至" class="zhi">
            <div class="block">
              <el-date-picker
                  v-model="filter.arriveTimeEnd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 165px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" prop="salesChangeOrderNO" label="变更编号" width="90"/>
      <el-table-column align="center" prop="changeAmount" label="变更金额" width="80"/>
      <el-table-column align="center" prop="customerName" label="客户名称" width="200"/>
      <el-table-column align="center" prop="creator" label="创建人" width="80"/>
      <el-table-column align="center" prop="createTime" label="创建时间" width="200"/>
      <el-table-column align="center" prop="submitTime" label="提交时间" width="200"/>
      <el-table-column align="center" prop="orderNOStr" label="出厂编号"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "SalesExportExcelList",
    components: {VmTable, VmSearch},
    data() {
      return {
        exportLoading: false,
        departmentList: [],
        filter: {
          salesChangeOrderNO: "",
          creator: "",
          orderNoStr: "",
          customerName: "",
          arriveTimeBegin:"",
          arriveTimeEnd:"",
          departmentID:"",
          departmentName:"",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
      this.getDepartmentList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getDepartmentList() {
        this.$http
          .get("basic", "departments/list")
          .then(resp => {
            this.departmentList = resp;
          });
      },
      selectDepartment(row) {
        this.filter.departmentID = row.departmentID;
        this.filter.departmentName = row.departmentName;
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "changeOrder/export", this.filter)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      exportSalesChangeOrderQuality() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "changeOrder/exportSalesChangeOrderQuality", this.filter)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss">
</style>
